export default __webpack_public_path__ + "static/media/ntu_logo.ff1c40a9.png";